import React from 'react';

const SvgVu = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="VU_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
      <path id="VU_svg__d" d="M0 12h28v8H0z" />
      <filter
        x="-5.4%"
        y="-18.8%"
        width="110.7%"
        height="137.5%"
        filterUnits="objectBoundingBox"
        id="VU_svg__c"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
      <path id="VU_svg__f" d="M0 0h28v8H0z" />
      <filter
        x="-5.4%"
        y="-18.8%"
        width="110.7%"
        height="137.5%"
        filterUnits="objectBoundingBox"
        id="VU_svg__e"
      >
        <feMorphology
          radius={0.5}
          operator="dilate"
          in="SourceAlpha"
          result="shadowSpreadOuter1"
        />
        <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          in="shadowOffsetOuter1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="VU_svg__b" fill="#fff">
        <use xlinkHref="#VU_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#VU_svg__a" />
      <g mask="url(#VU_svg__b)">
        <use fill="#000" filter="url(#VU_svg__c)" xlinkHref="#VU_svg__d" />
        <use fill="#009543" xlinkHref="#VU_svg__d" />
      </g>
      <g mask="url(#VU_svg__b)">
        <use fill="#000" filter="url(#VU_svg__e)" xlinkHref="#VU_svg__f" />
        <use fill="#D21034" xlinkHref="#VU_svg__f" />
      </g>
      <path fill="#262626" mask="url(#VU_svg__b)" d="M0 8h28v4H0z" />
      <path fill="#262626" mask="url(#VU_svg__b)" d="M0 0l13.333 10L0 20z" />
      <path
        d="M-.667 2.637v14.726L9.528 10-.667 2.637z"
        stroke="#FDCE12"
        strokeWidth={1.333}
        mask="url(#VU_svg__b)"
      />
      <path
        fill="#FDCE12"
        mask="url(#VU_svg__b)"
        d="M9.333 9.333H28v1.333H9.333z"
      />
    </g>
  </svg>
);

export default SvgVu;
